export const categories = ['희신', '구신', '기신', '한신', '용신']

/** 차트 좌우 여백 넣기위해 만든 카테고리 */
export const expandedCategories = ['', '희신', '', '구신', '', '기신', '', '한신', '', '용신']

export const barColors = {
  희신: 'rgba(var(--v-theme-fiveColor03), 1)',
  구신: 'rgba(var(--v-theme-fiveColor01), 1)',
  기신: 'rgba(var(--v-theme-fiveColor05), 1)',
  한신: 'rgba(var(--v-theme-fiveColor04), 1)',
  용신: 'rgba(var(--v-theme-fiveColor02), 1)',
}

/**
 * 차트별 컬러
 * 
 * 'bar', 'line', 'line' 순으로 작성
 * -> 막대 차트는 DOM 조작으로 색상을 변경하기 때문에 투명으로 설정
 */
export const chartColors = ['transparent', '#F47A49']